import http from './http';

const mapItems = (res) => res.data?.items ?? res.data?.data ?? res.data ?? [];

export async function listSpecialties() {
  const res = await http.get('/specialties');
  return mapItems(res);
}

export async function listStates() {
  const res = await http.get('/address/states');
  return mapItems(res);
}

export async function listCities(id) {
  const res = await http.get('/address/cities/' + id);
  return mapItems(res);
}

export async function listGenders() {
  const res = await http.get('/catalogs/genders');
  return mapItems(res);
}
export async function listMainGoals() {
  const res = await http.get('/catalogs/main_goals');
  return mapItems(res);
}
export async function listFitnessLevels() {
  const res = await http.get('/catalogs/fitness_levels');
  return mapItems(res);
}

export async function listRoutineLevels() {
  const res = await http.get('/catalogs/routine_levels');
  return mapItems(res);
}

export async function listRoutineTypes() {
  const res = await http.get('/catalogs/routine_types');
  return mapItems(res);
}

export async function listRoutineDurations() {
  const res = await http.get('/catalogs/routine_durations');
  return mapItems(res);
}

export async function listRoutinePlans() {
  const res = await http.get('/catalogs/routine_plans');
  return mapItems(res);
}

export async function listRoutineFocuses() {
  const res = await http.get('/catalogs/routine_focuses');
  return mapItems(res);
}

export async function listRoutineLocations() {
  const res = await http.get('/catalogs/routine_locations');
  return mapItems(res);
}

export async function listExerciseTypes() {
  const res = await http.get('/catalogs/exercise_types');
  return mapItems(res);
}

// CRUD
export async function listCatalog(name, params = {}) {
  const res = await http.get(`/catalogs/${name}`, { params });
  return mapItems(res);
}

export async function createCatalogItem(name, payload) {
  const res = await http.post(`/catalogs/${name}`, payload);
  return res.data;
}

export async function updateCatalogItem(name, id, payload) {
  const res = await http.put(`/catalogs/${name}/${id}`, payload);
  return res.data;
}

export async function deleteCatalogItem(name, id) {
  const res = await http.delete(`/catalogs/${name}/${id}`);
  return res.data;
}

export async function updateCatalogItemStatus(name, id, isActive) {
  const res = await http.patch(`/catalogs/${name}/${id}/status`, { is_active: isActive });
  return res.data;
}

export async function listDashboard(params = {}) {
  const res = await http.get('/admin/dashboard', { params });
  return mapItems(res);
}

export async function listClientRoles() {
  const res = await http.get('/user/roles');
  return mapItems(res);
}